import { Configuration as CvpApiConfig } from './cvpapi/configuration';
import { Configuration as ProxyConfig } from './proxy/configuration';
import { PeAnApi, PublicDataApi, HaKuBuApi } from './cvpapi/api';
import { ApiProxyApi } from './proxy/api';
import axios from 'axios';
class ApiEndpoints {
    constructor() {
        this.basePathCvpApi = process.env.VUE_APP_CVPNET_API_BASEURL;
        this.basePathProxyApi = process.env.VUE_APP_CVPNET_PROXY_API_BASEURL;
        this.cvpApiConfiguration = null;
        this.proxyConfiguration = null;
        this.createConfiguration();
        this.addInterceptors();
    }
    addInterceptors() {
        axios.interceptors.request.use(request => {
            request.headers['CvpService'] = `PeAn`;
            return request;
        });
    }
    createConfiguration() {
        const cvpApiConfig = new CvpApiConfig({ basePath: this.basePathCvpApi });
        const proxyConfig = new ProxyConfig({ basePath: this.basePathProxyApi });
        this.cvpApiConfiguration = cvpApiConfig;
        this.proxyConfiguration = proxyConfig;
    }
    get basePath() {
        return this.cvpApiConfiguration.basePath;
    }
    get ApiProxy() {
        return new ApiProxyApi(this.proxyConfiguration);
    }
    get HaKuBu() {
        return new HaKuBuApi(this.cvpApiConfiguration);
    }
    get PublicData() {
        return new PublicDataApi(this.cvpApiConfiguration);
    }
    get PeAn() {
        return new PeAnApi(this.cvpApiConfiguration);
    }
}
export const Api = new ApiEndpoints();
